/* eslint-disable no-empty */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
$(document).ready(function () {



  var total = 0,
    indirimtotal = 0,
    kdvtotal = 0,
    faturatotal = 0,
    gidecektotal = 0,
    gidecekindirimtotal = 0,
    gidecekkdvtotal = 0,
    gidecekfaturatotal = 0;
  var turkishMessages = {
    serverCommunicationError: 'Sunucu ile iletişim kurulurken bir hata oluştu.',
    loadingMessage: 'Kayıtlar yükleniyor...',
    noDataAvailable: 'Hiç kayıt bulunmamaktadır!',
    addNewRecord: 'Yeni kayıt ekle',
    editRecord: 'Kayıt düzenle',
    areYouSure: 'Emin misiniz?',
    deleteConfirmation: 'Bu kayıt silinecektir. Emin misiniz?',
    save: 'Kaydet',
    saving: 'Kaydediyor',
    cancel: 'İptal',
    deleteText: 'Sil',
    deleting: 'Siliyor',
    error: 'Hata',
    close: 'Kapat',
    cannotLoadOptionsFor: '{0} alanı için seçenekler yüklenemedi!',
    pagingInfo: 'Gösterilen: {0}-{1}, Toplam: {2}',
    pageSizeChangeLabel: 'Satır sayısı',
    gotoPageLabel: 'Sayfaya git',
    canNotDeletedRecords: '{1} kayıttan {0} adedi silinemedi!',
    deleteProggress: '{1} kayıttan {0} adedi silindi, devam ediliyor...'
  };

  $('#tblSepet').jtable({
    messages: turkishMessages,
    paging: false,
    pageSize: 15,
    sorting: false,
    defaultSorting: '',
    addRecordButton: false,
    saveUserPreferences: false,
    create: false,
    edit: false,
    actions: {
      listAction: '/WebMethods.aspx/SepetGoster?kullaniciId=2336'
    },

    fields: {
      Id: {
        title: '',
        visibility: 'hidden'
      },
      UrunId: {
        title: '',
        visibility: 'hidden'
      },
      NAME: {
        title: 'Ürün Adı',
        display: function (data) {
          //return '<a target="_blank" style="color:#4D90FE" href="/Istem/Urun/Detay.aspx?Id=' + data.record.DetayId + '">' + data.record.Urun_Ad + '</a><br><span style="font-size:10px;">' + data.record.Barkod + '</span><br><span style="font-size:10px;">' + data.record.Yayinevi + '</span><br><span style="font-size:10px;">' + data.record.Yazar + '</span>';
          return '<a target="_blank" style="color:#4D90FE" href="/Istem/Urun/Detay.aspx?Id=' + data.record.DetayId + '">' + data.record.Urun_Ad + '</a><br><span style="font-size:10px;">' + data.record.Barkod + '</span>';
        },
        width: '30%'
      },
      Yazar: {
        title: 'Yazar',
        display: function (data) {
          return '<span style="font-size:10px;">' + data.record.Yazar + '</span><br><span style="font-size:10px;color:blue;">' + data.record.Yayinevi + '</span>';
        },
        width: '14%'
        //,
        //visibility: 'hidden'
      },
      Yayinevi: {
        title: 'YayınEvi',
        width: '1%',
        visibility: 'hidden'
      },
      Barkod: {
        title: 'Barkod',
        width: '1%',
        visibility: 'hidden'
      },
      Birim_Fiyat: {
        title: 'Birim',
        width: '5%',
        display: function (data) {
          return '<div style="text-align:right;"><span class="para">' + data.record.Birim_Fiyat.toFixed(2) + '</span></div>'
        },
      },
      Iskonto1: {
        title: 'İsk.',
        width: '2%',
        display: function (data) {
          return '<div style="text-align:right;"><span Id="spnIskonto' + data.record.Id + '">% ' + data.record.Iskonto1 + '</span></div>'
        },
      },
      Indirim_Fiyat: {
        title: 'Net',
        width: '7%',
        display: function (data) {
          return '<div style="text-align:right;"><span class="para">' + data.record.Indirim_Fiyat.toFixed(2) + '</span></div>'
        },
      },
      Adet: {
        title: 'Adet',
        display: function (data) {
          return '<input type="type" name="Adet" class="r_corners type_2" style="width:55px" id="Adet' + data.record.Id + '" size="4" value="' + data.record.Miktar + '"/>';
        },
        width: '1%'
      },
      STOK: {
        title: 'Stok',
        display: function (data) {
          return '<div style="text-align:center;font-size:12px;"><span>' + data.record.STOK + '</span></div>'
        },
        width: '12%'
      },
      //Tutar: {
      //    title: 'Tutar',
      //    display: function (data) {
      //        return '<div style="text-align:right;"><span class="para">' + data.record.Tutar.toFixed(2) + '</span></div>'
      //    },
      //    width: '7%'
      //},
      UrunTutar: {
        title: '',
        display: function (data) {
          return '<span class="UrunTutar" id="spnKdvTutar' + data.record.Id + '">' + data.record.UrunTutar + '</span>'
        },
        visibility: 'hidden'
      },
      IndirimTutar: {
        title: '',
        display: function (data) {
          return '<span class="IndirimTutar" id="spnKdvTutar' + data.record.Id + '">' + data.record.IndirimTutar + '</span>'
        },
        visibility: 'hidden'
      },
      KDVTutar: {
        title: '',
        display: function (data) {
          return '<span class="KdvTutar" id="spnKdvTutar' + data.record.Id + '">' + data.record.KDVTutar + '</span>'
        },
        width: '5%',
        visibility: 'hidden'
      },
      KDV: {
        title: '',
        display: function (data) {
          return '<span class="Kdv" id="spnKdv' + data.record.Id + '">' + data.record.KDV + '</span>'
        },
        width: '5%',
        visibility: 'hidden'
      },
      İşlem: {
        title: '',
        display: function (data) {
          return '<a style="cursor:pointer;" class="tr_delay_hover r_corners button_type_16 f_size_medium color_dark bg_light_color_2" onclick="SepetGuncelle(' + data.record.Id + ')" >Güncelle</a>';
        },
        width: '1%'
      },
      İşlem2: {
        title: '',
        display: function (data) {
          return '<a style="cursor:pointer;" class="tr_delay_hover r_corners button_type_16 f_size_medium bg_scheme_color color_light m_xs_bottom_5" onclick="SepetSil(' + data.record.Id + ')" >Sil</a>';
        },
        width: '1%'
      }
    },
    recordsLoaded: function (event, data) {

      $('.jtable thead th:nth-child(7) div').attr('style', 'text-align:center; ');
      $('.jtable thead th:nth-child(8) div').attr('style', 'text-align:center; ');
      $('.jtable thead th:nth-child(9) div').attr('style', 'text-align:center; ');
      $('.jtable thead th:nth-child(12) div').attr('style', 'text-align:center; ');

      total = 0;
      indirimtotal = 0;
      kdvtotal = 0;
      faturatotal = 0;
      gidecektotal = 0;
      gidecekindirimtotal = 0;
      gidecekkdvtotal = 0;
      gidecekfaturatotal = 0;

      for (var i in data.records) {
        total += parseFloat(data.records[i].UrunTutar);
        $('#GenelTutar').html(total.toFixed(2) + '');
        var adet = 0
        if (data.records[i].STOK != 0) {
          if (data.records[i].STOK < data.records[i].Miktar)
            adet = data.records[i].STOK;
          else
            adet = data.records[i].Miktar;
        }
        //alert(adet);
        gidecektotal += parseFloat(data.records[i].Birim_FiyatKDVsiz) * adet;
        $('#GidecekTutar').html(gidecektotal.toFixed(2) + '');


        indirimtotal += parseFloat(data.records[i].IndirimTutar);
        $('#IndirimTutar').html(indirimtotal.toFixed(2) + '');


        gidecekindirimtotal += (parseFloat(data.records[i].Birim_FiyatKDVsiz) - parseFloat(data.records[i].Indirim_FiyatKDVsiz)) * adet;
        $('#GidecekIndirimTutar').html(gidecekindirimtotal.toFixed(2) + '');

        kdvtotal += parseFloat(data.records[i].KDVTutar);
        $('#KdvTutar').html(kdvtotal.toFixed(2) + '');

        gidecekkdvtotal += (parseFloat(data.records[i].Indirim_FiyatKDVsiz) * (parseFloat(data.records[i].KDV) / 100)) * adet;
        $('#GidecekKdvTutar').html(gidecekkdvtotal.toFixed(2) + '');

        faturatotal = (parseFloat(total) - parseFloat(indirimtotal)) + parseFloat(kdvtotal);
        $('#FaturaTutar').html(faturatotal.toFixed(2) + '');

        gidecekfaturatotal = (parseFloat(gidecektotal) - parseFloat(gidecekindirimtotal)) + parseFloat(gidecekkdvtotal);
        $('#GidecekFaturaTutar').html(gidecekfaturatotal.toFixed(2) + '');
        $('#lblgidecektutar').text(gidecekfaturatotal);
        //alert(gidecekfaturatotal);
        //$('#Kargo').html("Ücretsiz Kargo İçin Toplam 500TL değerinde sipariş vermelisiniz. Şu anki Tutarınız : " + gidecekfaturatotal.toFixed(2) + " TL'dir");

      }

      $('.para').priceFormat({
        prefix: '',
        suffix: ' TL',
        centsSeparator: ',',
        thousandsSeparator: '.'
      });

      $('.jtable tr:gt(0)').each(function () {

        var stok = $('td:eq(10)', $(this)).text();
        var adet = $('td:eq(9)', $(this)).find("input").val();

        if (parseInt(adet) > parseInt(stok)) {
          $('td:eq(10)', $(this)).css('background-color', '#E06666');
          $('td:eq(9)', $(this)).css('background-color', '#E06666');

        } else {
          $('td:eq(10)', $(this)).css('background-color', 'transparent');
          $('td:eq(9)', $(this)).css('background-color', 'transparent');
        }
      });


      SepetAdet();
    }
  });

  $('#tblSepet').jtable('load');
});

var sayac = 0,
  sayac2 = 0;

function KrediKartiAc(tip) {
  if (tip == 3)
    $('#divYanit').modal('show');
  else
    $('#divYanit2').modal('show');
}

$(document).ready(function () {
  $(".loader").fadeOut("slow");
});


function Sorgula() {
  SiparisOlustur();
}

function SepetSil(Id) {
  var adet = 0;
  var iskonto = 0;
  $.ajax({
    type: 'POST',
    url: '/WebMethods.aspx/SepetGuncelleMusteri',
    data: '{"Id":"' + Id + '","adet":"' + adet + '"}',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    success: function (result) {
      doPostBack();
    },
    error: function (resultx) {
      alert(resultx.d);
    }
  });
}

function SepetGuncelle(Id) {
  var adet = $('#Adet' + Id).val();
  var iskonto = $('#spnIskonto' + Id).val();
  $.ajax({
    type: 'POST',
    url: '/WebMethods.aspx/SepetGuncelleMusteri',
    data: '{"Id":"' + Id + '","adet":"' + adet + '"}',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    success: function (result) {
      doPostBack();
    },
    error: function (resultx) {
      alert(resultx.d);
    }
  });
}

function SiparisOlusturKapali() {
  toastr['success']("1 Ocak 2017 Tarihine kadar sayımdayız.", "Bilgi", {
    "closeButton": false,
    "debug": false,
    "positionClass": "toast-bottom-full-width",
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
  });
}

function SiparisOlustur() {
  $("#btnHemen").prop("disabled", true);
  $("#btnHemenKrediKarti").prop("disabled", true);
  $(".loader").fadeIn("slow");

  var kullaniciid = 2336

  $.ajax({
    type: 'POST',
    url: '/WebMethods.aspx/MusteriRisklimitveBakiyeSorgula',
    data: '{"musteriId":' + kullaniciid + '}',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    success: function (result) {
      if (result.d) {
        var deger = result.d;
        deger = "" + deger + "";
        bakiye = deger.split(';')[0];
        limit = deger.split(';')[1];
        sepet = deger.split(';')[2];
      }
    },
    error: function (resultx) {

    },
    complete: function () {
      if (parseFloat(bakiye) < 0 && parseFloat(limit) == 0) {
        if (parseFloat(bakiye) + parseFloat(sepet) < 0) {

        } else {
          $("#btnHemen").prop("disabled", false);
          $("#btnHemenKrediKarti").prop("disabled", false);
          $(".loader").fadeOut("slow");

          popupAc();
        }
      } else {
        if (parseFloat(limit) > 0) {

        } else {
          $("#btnHemen").prop("disabled", false);
          $("#btnHemenKrediKarti").prop("disabled", false);
          $(".loader").fadeOut("slow");

          popupAc();
        }
      }

      var odemetip = 0;
      odemetip = $('#ContentPlaceHolder1_cphSayfa_drpOdemeTip').val()

      var siparistip = 0;

      var urlstring = "";

      urlstring = '/WebMethods.aspx/HemenSiparisOlustur';

      $.ajax({
        type: 'POST',
        url: urlstring,
        data: '{"odemetip":"' + odemetip + '","secim":"' + siparistip + '"}',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: function (result) {
          if (result.d == "1")
            window.location.href = "/Istem/Siparis/Listele.aspx?giden=1";
          else
            window.location.href = "/Istem/Siparis/Listele.aspx?giden=2";
        },
        error: function (resultx) {
          //  alert(resultx.d);
        }
      });

    }
  });
}

function kontrol() {
  if (sayac == 0) {
    //alert("erdem1");
    return false;
  } else if (sayac == sayac2) {
    //alert("erdem2");
    return true;
  } else {
    //alert("erdem3")
    return false;
  }
}


function doPostBack() {
  toastr['success']("İşlem başarılı.", "Bilgi", {
    "closeButton": false,
    "debug": false,
    "positionClass": "toast-top-right",
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
  });

  $('#tblSepet').jtable('load');
}

function CustomAlert() {
  var tipx;
  this.render = function (dialog, tip) {
    var winW = window.innerWidth;
    var winH = window.innerHeight;
    var dialogoverlay = document.getElementById('dialogoverlay');
    var dialogbox = document.getElementById('dialogbox');
    tipx = tip;
    dialogoverlay.style.display = "block";
    dialogoverlay.style.height = winH + "px";
    dialogbox.style.left = (winW / 2) - (550 * .5) + "px";
    dialogbox.style.top = "100px";
    dialogbox.style.display = "block";
    document.getElementById('dialogboxhead').innerHTML = "Kargo Ücret Bilgisi";
    document.getElementById('dialogboxbody').innerHTML = dialog;
    document.getElementById('dialogboxfoot').innerHTML = '<input type="button" class="tr_delay_hover r_corners button_type_16 f_size_medium bg_dark_color bg_cs_hover color_light m_xs_bottom_5" onclick="CevapEvet(' + tipx + ')" value="Bu Şekilde Onayla"/>&nbsp;<input type="button" Id="cevapHayir" style="background: #e74c3c;color:#fff;" class="tr_delay_hover r_corners button_type_16 f_size_medium bg_scheme_color color_light m_xs_bottom_5" onclick="CevapHayir()" value="Alışverişe Devam Et"/>';
  }

  //    this.Hayir = function () {

  //        //alert("Hayıra bastın");
  //    }
  //}
}
var Alert = new CustomAlert();

function CevapEvet(tipcevap) {
  if (tipcevap == 0)
    SiparisOlustur();
  if (tipcevap == 1) {
    KrediKArtiOdemeYap();
    //alert("erdem");
    //window.location.href = "http://www.google.com";
    //window.open("http://www.w3schools.com");
  }
}

function CevapHayir() {
  document.getElementById('dialogbox').style.display = "none";
  document.getElementById('dialogoverlay').style.display = "none";
}

function tumsil() {

  var id2 = '';

  id2 = '2336';

  $.ajax({
    type: 'POST',
    url: '/WebMethods.aspx/SepetTumSilKullaniciId',
    data: '{"kullaniciId":"' + id2 + '"}',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    success: function (result) {
      SepetAdet();
      var tutar = 0;
      $('#GenelTutar').html(tutar.toFixed(2) + '');
      $('#GidecekTutar').html(tutar.toFixed(2) + '');
      $('#IndirimTutar').html(tutar.toFixed(2) + '');
      $('#GidecekIndirimTutar').html(tutar.toFixed(2) + '');
      $('#KdvTutar').html(tutar.toFixed(2) + '');
      $('#GidecekKdvTutar').html(tutar.toFixed(2) + '');
      $('#FaturaTutar').html(tutar.toFixed(2) + '');
      $('#GidecekFaturaTutar').html(tutar.toFixed(2) + '');

      doPostBack();

    },
    error: function (resultx) {
      alert(resultx.d);
    }
  });
}

function Sayfakapat() {
  $('#divGiris').bPopup().close();
}

function popupAc() {
  $('#divGiris').bPopup({
    appendTo: 'form',
    zIndex: 999,
    modalClose: true
  });
}

$('.qty .minus').bind('click', function () {
  var $input = $(this).parent().find('input'),
    val = Number($input.val());
  if (val > 1) {
    val--;
  }
  $input.val(val);
});

$('.qty .plus').bind('click', function (e) {
  var $input = $(this).parent().find('input'),
    val = Number($input.val());
  if (val >= 0) {
    val++;
  }
  $input.val(val);
});
